import { render, staticRenderFns } from "./IdleLoad.vue?vue&type=template&id=a8757f1c&scoped=true"
import script from "./IdleLoad.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdleLoad.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IdleLoad.vue?vue&type=style&index=0&id=a8757f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8757f1c",
  null
  
)

export default component.exports